<template>
    <v-navigation-drawer
        v-model="drawerState"
        :value="drawerState"
        disable-resize-watcher
        :clipped="$vuetify.breakpoint.mdAndUp"
        app
    >
        <v-list dense>
            <template v-for="menu in menus">
                <v-list-item
                    v-if="(menu.title && $helpers.isPrivate(menu))"
                    :key="menu.name"
                    :to="!menu.href ? { name: menu.name } : null"
                >
                    <v-list-item-action class="mx-3">
                        <v-badge
                            v-if="menu.badge && menu.badge.value > 0"
                            color="green"
                            :content="menu.badge.value"
                            left
                            overlap
                        >
                            <v-icon class="menu-icon">{{ menu.icon }}</v-icon>
                        </v-badge>
                        <v-icon v-else>{{ menu.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ menu.title }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'app-drawer',
    props: ['menus', 'drawer'],
    data () {
        return {
            drawerState: null
        }
    },
    watch: {
        drawer: function (val, oldVal) {
            this.drawerState = val
        },
        drawerState: function (val, oldVal) {
            this.$emit('update:drawer', val)
        }
    }
}
</script>
